import * as React from 'react'

import { AnalyticResults } from 'modules/enps/store/collections/analyticResults'
import type { AnalyticQuestionGroup, Cycle } from 'modules/enps/store/models/AnalyticResult'
import type EnpsForm from 'modules/enps/store/models/Form'

export interface Values {
  analyticResults: AnalyticResults
  answeredResults: AnalyticQuestionGroup[]
  answeredResultsCount: number
  cycle: Cycle | null
  filteredResults: AnalyticQuestionGroup[]
  filteredResultsCount: number
  form: EnpsForm
  loading: boolean
  setCycle: (cycle: Cycle) => void
}

export const resultsContext = React.createContext<Values | null>(null)

export const useAnalytics = (): Values => {
  const context = React.useContext(resultsContext)

  if (context === null) {
    throw new Error('useAnalytics must be used within an EnpsResultsContextProvider')
  }

  return context
}
